import angular from 'angular';
import _ from 'lodash';

export default angular.module('faq-errorcodes', []).run([
  'gettextCatalog',
  'appFactory',
  function errorCodes(gettextCatalog, appFactory) {
    appFactory.deps.config.errorCodes = _.merge(appFactory.deps.config.errorCodes, {
      faq: {
        13: () => ({ title: gettextCatalog.getString('Please select Category.') }),
        14: () => ({ title: gettextCatalog.getString('Category with specified name or ordinal number already exists. Please enter other name.') }),
        15: () => ({ title: gettextCatalog.getString('FAQ entry with specified name or ordinal number already exists. Please enter other name.') }),
        16: () => ({ title: gettextCatalog.getString('Specified FAQ category does not exist.') }),
        17: () => ({ title: gettextCatalog.getString('Specified FAQ category is not empty. You cannot delete FAQ category which contains questions.') }),
        FAQ_CATEGORY_ALREADY_EXIST: () => ({ title: gettextCatalog.getString('Category with specified name or ordinal number already exists. Please enter other name.') }),
        FAQ_ENTRY_ALREADY_EXIST: () => ({ title: gettextCatalog.getString('FAQ entry with this name or ordinal number already exists.') }),
      },
    });
  },
]);



// WEBPACK FOOTER //
// ./src/modules/faq/config/errorcodes.conf.js